module.exports = __webpack_public_path__ + "media/images/home/icon-cb92ee280d6199f886e904ebee3671bc.svg";